import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";

export const StyledTabs = styled(Tabs)(() => ({
  display: "flex",
  height: "50px",
  alignItems: "center",
}));
